import React from 'react'
import cs from 'classnames'
import styles from './KeyValue.scss'

const KeyValue = ({array, divider, customClass = ''}) => (
	<div className={cs(styles.moduleSectionContent, customClass)}>
		<div className={styles.detailsContainer}>
			{array.map((column, key) => <div key={key} className={styles.keyValueColumn}>
				{column.map((item, key) => (
					<div
						key={key}
						className={cs(
							styles.keyValuePair,
							divider === true && styles.divider
						)}
					>
						{!item.noLabel ?
							<div className={styles.keyCont}>
								<div className={styles.key}>{item.label}</div>
							</div>
						: ''}
						{item.value && (
							<div className={styles.valCont}>
								<div className={styles.value}>{item.value}</div>
							</div>
						)}
					</div>
				))}
			</div>)}
		</div>
	</div>
)

KeyValue.propTypes = {
	array: React.PropTypes.array.isRequired,
	divider: React.PropTypes.bool,
}

export default KeyValue



// WEBPACK FOOTER //
// ./components/KeyValue.jsx